import { c as _c } from "react/compiler-runtime";
import { KeyValueTable, Price } from '@petsmart-ui/sparky';
import type { KeyValueRowProps } from './types';
export function KeyValueRow(t0) {
  const $ = _c(17);
  let customValue;
  let hide;
  let rest;
  let title;
  let value;
  let variant;
  let weight;
  if ($[0] !== t0) {
    ({
      title,
      value,
      customValue,
      weight,
      variant,
      hide,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = customValue;
    $[2] = hide;
    $[3] = rest;
    $[4] = title;
    $[5] = value;
    $[6] = variant;
    $[7] = weight;
  } else {
    customValue = $[1];
    hide = $[2];
    rest = $[3];
    title = $[4];
    value = $[5];
    variant = $[6];
    weight = $[7];
  }
  if (hide) {
    return null;
  }
  let t1;
  if ($[8] !== customValue || $[9] !== value || $[10] !== variant || $[11] !== weight) {
    t1 = customValue ?? <Price values={[value]} weight={weight} variant={variant} />;
    $[8] = customValue;
    $[9] = value;
    $[10] = variant;
    $[11] = weight;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== rest || $[14] !== t1 || $[15] !== title) {
    t2 = <KeyValueTable.Row data-testid="key-value-row" rowKey={title} rowValue={t1} {...rest} />;
    $[13] = rest;
    $[14] = t1;
    $[15] = title;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
}